/**
 * @generated SignedSource<<1c18c50e16edf2d2b1f1bc95de76ddfa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type sidebarPreview$data = {
  readonly events: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
      };
    }>;
  };
  readonly leaderboard: string | null | undefined;
  readonly ranking: {
    readonly rankingUsers: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly totalPoints: number;
        };
      }>;
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"sidebarPreviewEvents" | "sidebarPreviewLeaderboard">;
  readonly " $fragmentType": "sidebarPreview";
};
export type sidebarPreview$key = {
  readonly " $data"?: sidebarPreview$data;
  readonly " $fragmentSpreads": FragmentRefs<"sidebarPreview">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "orderBy"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "sidebarPreview",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "sidebarPreviewEvents"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "orderBy",
          "variableName": "orderBy"
        }
      ],
      "kind": "FragmentSpread",
      "name": "sidebarPreviewLeaderboard"
    },
    {
      "alias": "leaderboard",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "LEADERBOARD"
        }
      ],
      "kind": "ScalarField",
      "name": "configuration",
      "storageKey": "configuration(key:\"LEADERBOARD\")"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filterBy",
          "value": "UPCOMING"
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 3
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": "CHRONOLOGICAL"
        }
      ],
      "concreteType": "EventConnection",
      "kind": "LinkedField",
      "name": "events",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Event",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "events(filterBy:\"UPCOMING\",first:3,orderBy:\"CHRONOLOGICAL\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ClubRanking",
      "kind": "LinkedField",
      "name": "ranking",
      "plural": false,
      "selections": [
        {
          "alias": "rankingUsers",
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 5
            }
          ],
          "concreteType": "RankingUserConnection",
          "kind": "LinkedField",
          "name": "users",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RankingUserEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RankingUser",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "totalPoints",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "users(first:5)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Club",
  "abstractKey": null
};

(node as any).hash = "bea4dfbb6514e9cac4569bd2d4c4a5d7";

export default node;
